<template>
  <div>
    <section class="query-container">
      <el-form
        class="formWapper"
        action=""
        :model="formData"
        ref="formData"
        :rules="formRules"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="银行名称" prop="name">
          <el-input
            placeholder="请输入银行名称"
            prefix-icon="el-icon-document"
            style="width: 450px;  height: 40px;"
            clearable
            maxlength="50"
            v-model="formData.name"
          >
          </el-input>
        </el-form-item>
        
        <div class="verification-code">
          <el-form-item label="验证码" prop="code" style="width: 100%">
            <el-input
              placeholder="请输入验证码"
              prefix-icon="el-icon-edit"
              style="width: 340px; height: 40px"
              v-model="formData.code"
              maxlength="4"
              @keyup.enter.native="queryList('formData')"
            >
            </el-input>
          </el-form-item>
          <div class="code" @click="updateCode">
            <canvas id="canvas" width="100" height="38"></canvas>
          </div>
        </div>
        <div class="form-btn">
          <input
            type="button"
            class="submit"
            value="查询"
            @click="queryList('formData')"
          />
          <input type="reset" value="重置" @click="resetForm('formData')" />
        </div>
      </el-form>
    </section>

    <router-view :key="key"> </router-view>
  </div>
</template>
<script>
import { createCode } from "@/utils/checkCode";
import { requestJpaas, requestJpaas1 } from "@/api/code";
import IndexApi from "@/api/index";
import { getUserInfo, getToken } from "@/api/userInfo";
import tools from "../tools/tool";
import { tool } from "../tools/toolCommon";
export default {
  name: "IndexView",
  async mounted() {
    // 获取验证码
    await this.queryCode();
    this.$nextTick(() => {
      createCode(this.captcha.sandCode);
    })
    this.getUserInfo()
  },
  data() {
    const checkValue1 = async (rule, value, callback) => {
    const pattern =/[`~!@#$^&*=|{}':;',\\[\]<>/?~！@#￥……&%*——|{}【】'；：""'。，、？\s]/g;
      if (pattern.test(this.formData.name)) {
        return callback(new Error("不能输入特殊符号"));
      }
      callback();
    };
    const checkCode = async (rule, value, callback) => {
      await this.verifyCode();
      if (!this.codeFlag) {
        this.formData.code = "";
        this.updateCode();
        return callback(new Error("验证码错误"));
      }
      callback();
    };
    const changeInput1=(rule, value, callback)=>{
      let regex = /\s+/;
      if (regex.test(value)){
        callback(new Error("不能含有空格换行"));
      }else{
        callback();
      }
    };
    return {
      key: 0,
      formData: {
        name:'',
        num:'',
        code: ''
      },
      code: "",
      captcha: {
        uuid: "",
        sandCode: "",
      },
      formRules: {
        name:[
          { validator: changeInput1, trigger: "blur" },
          { validator: checkValue1, trigger: "blur" },
        ],
        code: [
          { required: true, message: "验证码不能为空", trigger: "blur" },
          { min: 4, max: 4, message: "验证码长度为4个字符", trigger: "blur" },
          { validator: checkCode, trigger: "click" },
        ],
      },
    };
  },
  methods: {

    // 获取用户信息
    async getUserInfo() {
      const loading = this.$loading({
        fullscreen: true,
        text: "加载中,请稍等",
        spinner: "el-icon-loading",
        background: "rgba(f,f,f,0.7)",
      });
      await getUserInfo().then((res) => {
        console.log(res);
        // 获取token
        getToken().then((result) => {
          console.log(result, "result");
          if (res.code === "200") {
            loading.close();
            if (res.params.userType == "1") {
              console.log(res);
              let userInfo = res.params;
              userInfo.name = tool.desensitizationName(tools.decryptSM2(res.params.userName));
              userInfo.card = tool.desensitizationId(
                tools.decryptSM2(res.params.userId)
              );
              userInfo.phone = tool.desensitizationPhone(tools.decryptSM2(res.params.phone));
              userInfo.authCode = tools.decryptSM2(
                result.data.authCode,
                "0e967306db2ed5f93efb8eb41a1043cf4782824a5c5e41874ab3305e4db6e6e7"
              );
              userInfo.token = tools.decryptSM2(
                result.data.token,
                "0e967306db2ed5f93efb8eb41a1043cf4782824a5c5e41874ab3305e4db6e6e7"
              );
              this.userInfo = userInfo;
              this.header = {
                token: userInfo.token,
                "auth-code": userInfo.authCode,
              };
              sessionStorage.setItem('header',JSON.stringify(this.header))
              this.$store.commit("userInfo", userInfo);
              console.log(userInfo, "用户信息");
            } else {
              this.haveData = "false";
              this.$message.warning("本应用仅支持个人账号查询");
            }
          } else {
            loading.close();
            location.href =
              "https://zwfw.gansu.gov.cn/szgs/member/wwLogin/againLgin.do?againUrl=" +
              encodeURIComponent(location.href);
          }
        });
      });
    },
    queryList(formName) {
      this.$refs[formName].validate((valid) => {
        this.updateCode();
        if (valid) {
          this.$router.push("/")
          const params = {
            paramsEncode: tools.encrypt(
              JSON.stringify({
                yhjdh: '',
                yhmc: this.formData.name,
                sfdm: '',
                dsdm: '623000',
                page: 1,
                size: 5
              })
            ),
            method: "jcyhcx",
          };
          const loading = this.$loading({
            text: "Loading...",
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,0.9)",
            target: document.getElementById("resultDiag"),
          });
          IndexApi.queryList('lxgjjer', 'lxsgjjbl', params,this.header)
          .then((res) => {
            if (res.success && res.data) {
              const result = JSON.parse(tools.decrypt(res.data.data))
              if(result && result.data.length){
                sessionStorage.setItem('yhmc',this.formData.name)
                sessionStorage.setItem('result',JSON.stringify(result))
                this.$router.push("/results")
              }else{
                this.$router.push("/no-results")
              }
            } else {
              this.$router.push("/no-results")
            }
            loading.close();
            this.formData.code = ''
          })
          .catch(() => {
            this.$message({
              type: "error",
              message: "网络异常",
            })
            loading.close();
          })
        } else {
          return false;
        }
      });
    },
    async resetForm(formName) {
      const loading = this.$loading({
        fullscreen: true,
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
      });
      await this.updateCode();
      loading.close();
      this.$refs[formName].resetFields();
      sessionStorage.setItem('params','')
      sessionStorage.setItem('result','')
      this.$router.push("/")
    },
    // 获取验证码
    async queryCode() {
      const result = await requestJpaas.getData();
      if (result.code === "200") {
        this.captcha.uuid = result.data.captcha.uuid;
        this.captcha.sandCode = result.data.captcha.capStr;
      } else {
        this.$message({
          type: "error",
          message: "验证码获取失败，请重试或联系管理员",
        });
      }
    },
    // 验证码获取更新
    async updateCode() {
      this.captcha.uuid = "";
      this.captcha.sandCode = "";
      await this.queryCode();
      createCode(this.captcha.sandCode);
    },
    // 验证码校验
    async verifyCode() {
      try {
        let formData = new FormData();
        formData.append("uuid", this.captcha.uuid);
        formData.append("sandCode", this.formData.code);
        this.captcha.sandCode = this.formData.code;
        const result = await requestJpaas1.getData(this.captcha);
        if (result.code == "200") {
          this.codeFlag = true;
        } else {
          this.codeFlag = false;
        }
      } catch (e) {
        this.$message({
          type: "error",
          message: "验证码校验失败，请重试或联系管理员",
        });
      }
    },
  },
};
</script>

<style scoped>
.formWapper {
  margin-left: -70px;
}
.code {
  position: relative;
  left: -50px;
}
</style>
